import { render, staticRenderFns } from "./ChatCards.vue?vue&type=template&id=e2405cec&scoped=true&"
import script from "./ChatCards.vue?vue&type=script&lang=js&"
export * from "./ChatCards.vue?vue&type=script&lang=js&"
import style0 from "./ChatCards.vue?vue&type=style&index=0&id=e2405cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2405cec",
  null
  
)

export default component.exports